import { render, staticRenderFns } from "./BugFeedbackView.vue?vue&type=template&id=fbc72a66&scoped=true"
import script from "./BugFeedbackView.vue?vue&type=script&lang=js"
export * from "./BugFeedbackView.vue?vue&type=script&lang=js"
import style0 from "./BugFeedbackView.vue?vue&type=style&index=0&id=fbc72a66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbc72a66",
  null
  
)

export default component.exports